function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("ellipse", {
  id: "emergencies_xl_svg__a",
  cx: 41.576,
  cy: 4.02,
  rx: 41.576,
  ry: 4.02
}));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(85.47 225.329)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "emergencies_xl_svg__b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#emergencies_xl_svg__a"
})), /*#__PURE__*/React.createElement("g", {
  mask: "url(#emergencies_xl_svg__b)",
  stroke: "#371447",
  strokeLinecap: "square",
  strokeWidth: 3
}, /*#__PURE__*/React.createElement("path", {
  d: "M43.33-5.639L25.135 13.508M51.87-5.639L33.675 13.508M60.41-5.639L42.215 13.508M68.95-5.639L50.756 13.508M77.49-5.639L59.296 13.508M86.03-5.639L67.836 13.508M94.57-5.639L76.376 13.508M103.11-5.639L84.916 13.508M111.65-5.639L93.456 13.508M120.19-5.639l-18.194 19.147"
}))), /*#__PURE__*/React.createElement("path", {
  d: "M72.796 210.088c0 11.794 10.608 21.354 23.694 21.354 13.086 0 23.694-9.56 23.694-21.354",
  stroke: "#371447",
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("path", {
  d: "M120.184 149.06v60.222",
  stroke: "#371447",
  strokeWidth: 3,
  strokeLinecap: "square"
}), /*#__PURE__*/React.createElement("path", {
  d: "M218.576 137.951c0-55.036-45.034-99.651-100.588-99.651C62.435 38.3 17.4 82.915 17.4 137.951c10.29-2.258 17.565-3.388 21.827-3.388 8.379 0 15.242 3.388 20.588 3.388 9.149 0 18.625-5.206 30.146-5.206 7.645 0 18.655 5.206 31.313 5.206 8.33 0 19.706-4.366 30.207-4.366 9.901 0 18.806 4.366 30.638 4.366 4.41 0 10.72-3.877 18.321-3.877 3.57 0 9.616 1.293 18.136 3.877z",
  stroke: "#371447",
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("path", {
  d: "M62.05 118.355a98.22 98.22 0 016.486-20.257c8.13-18.299 22.04-34.748 41.73-49.348m62.701 69.605a98.22 98.22 0 00-6.487-20.257C158.35 79.8 144.44 63.35 124.75 48.75",
  stroke: "#371447",
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("path", {
  d: "M82.346 24.896c3.864 0 6.996-2.891 6.996-6.458 0-2.378-2.332-6.524-6.996-12.438-4.664 5.914-6.996 10.06-6.996 12.438 0 3.567 3.132 6.458 6.996 6.458zm-57 31.35c3.864 0 6.996-2.891 6.996-6.458 0-2.378-2.332-6.524-6.996-12.438-4.664 5.914-6.996 10.06-6.996 12.438 0 3.567 3.132 6.458 6.996 6.458zm130.15 116.85c3.864 0 6.996-2.891 6.996-6.458 0-2.378-2.332-6.524-6.996-12.438-4.664 5.914-6.996 10.06-6.996 12.438 0 3.567 3.132 6.458 6.996 6.458zm64.6-116.85c3.864 0 6.996-2.891 6.996-6.458 0-2.378-2.332-6.524-6.996-12.438-4.664 5.914-6.996 10.06-6.996 12.438 0 3.567 3.132 6.458 6.996 6.458zm-59.85-31.35c3.864 0 6.996-2.891 6.996-6.458 0-2.378-2.332-6.524-6.996-12.438-4.664 5.914-6.996 10.06-6.996 12.438 0 3.567 3.132 6.458 6.996 6.458zm-41.8 65.55c3.864 0 6.996-2.891 6.996-6.458 0-2.378-2.332-6.524-6.996-12.438-4.664 5.914-6.996 10.06-6.996 12.438 0 3.567 3.132 6.458 6.996 6.458zm-71.25 20.9c3.864 0 6.996-2.891 6.996-6.458 0-2.378-2.332-6.524-6.996-12.438-4.664 5.914-6.996 10.06-6.996 12.438 0 3.567 3.132 6.458 6.996 6.458zm142.5 0c3.864 0 6.996-2.891 6.996-6.458 0-2.378-2.332-6.524-6.996-12.438-4.664 5.914-6.996 10.06-6.996 12.438 0 3.567 3.132 6.458 6.996 6.458zm-1.9 97.85c3.864 0 6.996-2.891 6.996-6.458 0-2.378-2.332-6.524-6.996-12.438-4.664 5.914-6.996 10.06-6.996 12.438 0 3.567 3.132 6.458 6.996 6.458zm38.95-36.1c3.864 0 6.996-2.891 6.996-6.458 0-2.378-2.332-6.524-6.996-12.438-4.664 5.914-6.996 10.06-6.996 12.438 0 3.567 3.132 6.458 6.996 6.458zm-213.75 0c3.864 0 6.996-2.891 6.996-6.458 0-2.378-2.332-6.524-6.996-12.438C8.332 160.114 6 164.26 6 166.638c0 3.567 3.132 6.458 6.996 6.458zm34.2 32.3c3.864 0 6.996-2.891 6.996-6.458 0-2.378-2.332-6.524-6.996-12.438-4.664 5.914-6.996 10.06-6.996 12.438 0 3.567 3.132 6.458 6.996 6.458zm38-32.3c3.864 0 6.996-2.891 6.996-6.458 0-2.378-2.332-6.524-6.996-12.438-4.664 5.914-6.996 10.06-6.996 12.438 0 3.567 3.132 6.458 6.996 6.458z",
  fill: "#4DD0E1"
}));

function SvgEmergenciesXl(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 240,
    viewBox: "0 0 240 240",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _ref, _ref2);
}

export default SvgEmergenciesXl;